import type { MarketingAutomaticoItem } from "../models/marketingAutomaticoModel"

export enum MarketingAutomaticoActionsTypes {
    CARREGAR = "CARREGAR",
    ADICIONAR_OU_ATUALIZAR = "ADICIONAR_OU_ATUALIZAR",
    REMOVER = "REMOVER",
}

export type MarketingAutomaticoAction =
    | { type: MarketingAutomaticoActionsTypes.CARREGAR; payload: MarketingAutomaticoItem[] }
    | { type: MarketingAutomaticoActionsTypes.ADICIONAR_OU_ATUALIZAR; payload: MarketingAutomaticoItem }
    | { type: MarketingAutomaticoActionsTypes.REMOVER; payload: number }
